<template>
    <a-select :options="dicData"   v-model="modelValue" :placeholder="placeholder">
    </a-select>
</template>

<script setup>
import {Select as aSelect,Option as aOption} from "@arco-design/web-vue"
const props=defineProps({
    dicData: {
        type: Array,
        default: () => []
    },
    placeholder: {
        type: String,
        default: 'Please select ...'
    }
})
const modelValue=defineModel()

</script>
